import ViolationsRemediateAction from './ViolationsRemediateAction';

export default ViolationsRemediateAction;
